export default function appReducer(state, action) {
  switch (action.type) {
    // AUTH REDUCERS
    case 'SET_AUTHENTICATION': {
      return { ...state, isAuthenticated: true };
    }
    case 'SET_USER': {
      window.localStorage.setItem('user', JSON.stringify(action.payload));
      return { ...state, user: action.payload };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
